export let AgreementChangeType = /*#__PURE__*/function (AgreementChangeType) {
  AgreementChangeType["CoverCreditCardFees"] = "creditCardFeesCoverChangeData";
  AgreementChangeType["CoverDirectDebitFees"] = "directDebitFeesCoverChangeData";
  AgreementChangeType["NetTerms"] = "netTermsChangeData";
  AgreementChangeType["AmendmentsApprovalMethod"] = "amendmentsApprovalMethodChangeData";
  AgreementChangeType["InvoicesApprovalMethod"] = "invoicesApprovalMethodChangeData";
  AgreementChangeType["BillingDayOfWeek"] = "relationshipBillingDayOfWeekChangeData";
  AgreementChangeType["LegalTermsOld"] = "legalTermsChangeData";
  AgreementChangeType["legalTermsDocuments"] = "legalTermsDocumentsChangeData";
  AgreementChangeType["Services"] = "serviceChangeData";
  AgreementChangeType["ManualPayments"] = "manualPaymentsChangeData";
  AgreementChangeType["Title"] = "titleChangeData";
  AgreementChangeType["Seller"] = "sellerChangeData";
  AgreementChangeType["ServiceQboClass"] = "serviceIntegrationClassChangeData";
  return AgreementChangeType;
}({});